import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ account, discussion, comment }) =>
    present(
      repository
        .getUserHumanResource(account)
        .then((author) =>
          repository.saveComment(discussion, { ...comment, author }),
        )
        .then((comment) => ({ account, discussion, comment }))
        .catch(() => Promise.reject({ account, discussion, comment })),
    );
}

export type { Interactor };

export { createInteractor };
